
document.addEventListener('DOMContentLoaded', function () {
  const desc = document.querySelector('[data-collection-description]');
  const btn  = document.querySelector('[data-collection-readmore]');
  if (!desc || !btn) return;

  // Helper: checks if the content is actually truncated
  const isTruncated = () => desc.scrollHeight > desc.clientHeight + 2;

  // Initially decide whether to show button
  // Temporarily ensure collapsed state to measure correctly
  desc.classList.remove('is-expanded');
  if (isTruncated()) {
    btn.hidden = false;
  } else {
    btn.hidden = true;
  }

  // Toggle expand/collapse
  btn.addEventListener('click', function () {
    const expanded = desc.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? 'Read Less' : 'Read More';
  });

  // Optional: re-check on resize for responsive line-clamp changes
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!desc.classList.contains('is-expanded')) {
        btn.hidden = !isTruncated();
      }
    }, 150);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const desc = document.querySelector('[data-collection-description]');
  const btn  = document.querySelector('[data-collection-readmore]');
  if (desc && btn) {
    // Helper: checks if the content is actually truncated
    const isTruncated = () => desc.scrollHeight > desc.clientHeight + 2;

    // Initially decide whether to show button
    desc.classList.remove('is-expanded');
    if (isTruncated()) {
      btn.hidden = false;
    } else {
      btn.hidden = true;
    }

    // Toggle expand/collapse
    btn.addEventListener('click', function () {
      const expanded = desc.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read Less' : 'Read More';
    });

    // Optional: re-check on resize for responsive line-clamp changes
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!desc.classList.contains('is-expanded')) {
          btn.hidden = !isTruncated();
        }
      }, 150);
    });
  }
});

// **************** Product Description COA Link ******************
(function() {
  function addTargetBlank() {
    document.querySelectorAll('.product-description a').forEach(function(link) {
      if (!link.hasAttribute('target')) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  // Run at multiple points
  document.addEventListener('DOMContentLoaded', addTargetBlank);
  window.addEventListener('load', addTargetBlank);
  setTimeout(addTargetBlank, 1000);
  setTimeout(addTargetBlank, 2500);

  // Watch for modal content changes (quickshop)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(addTargetBlank, 100);
      }
    });
  });

  // Observe the modal container
  const modalContainer = document.querySelector('[data-modal-container]');
  if (modalContainer) {
    observer.observe(modalContainer, { 
      childList: true, 
      subtree: true 
    });
  }

  // Also observe body for dynamically added modals
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
})();

// ============================= Judge me stars ===========================
// Force ONLY the carousel header stars to be ON (Judge.me repaints, so we retry)
(() => {
  const SELECTOR =
    '.jdgm-carousel-title-and-link .jdgm-all-reviews-rating .jdgm-star';

  function apply() {
    const stars = document.querySelectorAll(SELECTOR);
    if (!stars.length) return false;

    stars.forEach((star) => {
      star.classList.remove('jdgm--off');
      star.classList.add('jdgm--on');
      star.style.opacity = '1';
    });

    return true;
  }

  // Try now, on load, and a few times after (Judge.me often repaints)
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    apply();

    if (tries >= 30) clearInterval(timer); // ~6 seconds
  }, 200);

  // Also watch for re-renders
  const obs = new MutationObserver(() => apply());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(() => obs.disconnect(), 10000);
})();



